// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"eb8477c3","492":"2297d5b2","597":"202ac883","789":"995188ab","860":"2bd8a9df"}[chunkId] + ".chunk.js";
};